import SidePanelStyle from '@/styles/components/careers/side-panel/_index.module.scss';
import { Accordion, AccordionItem, AccordionItemHeading, AccordionItemButton, AccordionItemPanel } from "react-accessible-accordion"; 
import { EdiText, useState, EditImage, AddSection, REDIRECT, Button } from '@/imports-files/pages/career/customize-career-page';
import CrossIcon from 'public/icons/career_icons/closebtn.svg';
import Tooltip from "react-simple-tooltip";

export function SidePanel({ formik, router, customizeCareerAction, setResetCareerPage, setLoading, sidebar_section, setFonts, formRef})
{

  return(
    <div id="career_SidePanel" className={`${SidePanelStyle.SidePanel}`}>
      <div className={`${SidePanelStyle.SidePanel__Padding18}`}>
        <div className={`${SidePanelStyle.SidePanel__DFlex}`}>
          <a className={`${SidePanelStyle.SidePanel__CloseBtn}`} onClick={() => customizeCareerAction.showHideSidePanel(false)}><CrossIcon /></a>
            <div className={`${SidePanelStyle.SidePanel__PreviewPublishBtns}`}>
             <Button type="button" buttonstyle={`${SidePanelStyle.SidePanel__PreviewPublishBtns__Reset}`}
              disabled={!formik.values.can_reset}
              onClick={()=> {
                setResetCareerPage(true)
              }}
              >Reset
            </Button>

            <button type = "button" className={`${SidePanelStyle.SidePanel__PreviewPublishBtns__Preview}`}
              onClick={() => {
                customizeCareerAction.redirectToPreview()
                // customizeCareerAction.showHideSidePanel(false)
              }}
            >Preview</button>
            <div className = {`${SidePanelStyle.SidePanel__PublishBtn}`}>
              <Tooltip className='SimpleTooltip' content="Your changes have not been published. Please press “Publish” in the Settings panel to retain your changes." background= {'#00325A'} radius={20} padding = {10} placement = "bottom" fixed = {false} fontSize= "11px">
                <div className = {`tooltipwidth145`}>
                <button type = "button" className={`${SidePanelStyle.SidePanel__PreviewPublishBtns__Publish}`}
                onClick={() => {
                  setLoading(true)
                  customizeCareerAction.publishCareerPage(formik, setLoading)
                  // customizeCareerAction.showHideSidePanel(false)
                }}
              >Publish</button>
              </div>
              </Tooltip>
            </div>
          </div>
        </div>
        <AddSection
          formik={formik}
          sidebar_section={sidebar_section}
          customizeCareerAction={customizeCareerAction}
          setFonts={setFonts}
          formRef={formRef}
         />
      </div>
    </div>
  )
}
